const states = {
  isReceiveBtnDisabled: false,    // 领取按钮状态
  isReceiveStatus: false,         // 领取状态
  upSpecilId: '',                 // 上规格id
  downSpecilId: '',               // 下规格id
  skuId: '',                      // skuId
  isSpecil: false,                // 是否是多规格
};
export default states;
